var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TermsCom',{staticClass:"pc-doc container",attrs:{"title":"BLUE RIDGE TERMS OF SERVICE"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }